import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from './http-common.service';
import { DiaryBookingRequest } from '../interface/dairyBookingReques';

@Injectable({
	providedIn: 'root',
})
export class CommonService {
	constructor(private httpCommonService: HttpCommonService, private http: HttpClient) { }

	postDiarySlot(inputData: any): Observable<any> {
		return this.httpCommonService.postRecord(`diary/slots`, inputData);
	}

	postOrderUpdate(inputData: any): Observable<any> {
		return this.httpCommonService.postRecord(`order`, inputData);
	}

	postDiaryBooking(inputData: DiaryBookingRequest): Observable<any> {
		return this.httpCommonService.postRecord(`diary/booking`, inputData);
	}

	getWismoDetails(inputData: any): Observable<any> {
		return this.httpCommonService.getRecord(
			`wismo?upi=${inputData.upi}&postcode=${inputData.postcode}&requested_by=${inputData.requestedBy}`
		);
		// return this.http.get('/assets/mock-data/order-details.json');
	}

	getUpiByOrderNumber(orderNumber: any): Observable<any> {
		return this.httpCommonService.getRecord(`getupi?order_number=${orderNumber}`);
	}

	getAlert(currentDate: any): Observable<any> {
		return this.httpCommonService.getRecord(`alerts?currentdate=${currentDate}`);
	}
}
